import { ENTERPRISE_50_URL } from "@util/constant";

/**
 * component to render in Rules tab at How to Nominate page E50
 */
const RulesPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-250 p-4 font-public-sans"
      data-testid="rules-page-component"
    >
      <p>
        These rules and regulations establish the terms and conditions of your
        participation in the 2026 E50 Awards. Submission of your nomination
        implies that you accept these terms and conditions. Please read them
        before submitting your nomination.
      </p>

      <ul className="list-outside list-decimal pl-8">
        <li className="mb-4">
          By submitting a nomination for the E50 Awards, you hereby warrant that
          you have full ownership rights over, or possess a validly granted
          license or right to, or have obtained the required consent from the
          owner(s) to submit the requested information and material to the
          organisers in connection with your participation in the E50 Awards
          nominations. You hereby permit and authorise the organisers to use all
          submitted information, data and materials for purposes including but
          not limited to, research and analysis purposes which might involve
          third party researchers and the publication of a report by third
          parties. You hereby agree and undertake to indemnify and hold the
          organisers harmless against any claims, proceedings, damages, losses
          and costs (including legal fees on an indemnity basis) that may arise
          in connection with the breach of the above warranties or in the event
          the above representations and authorisation are untrue or invalid.
        </li>
        <li className="mb-4">
          Submission cannot be withdrawn without the prior approval and decision
          of the organisers.
        </li>
        <li className="mb-4">
          The judge&apos;s decision on all aspects of this award including
          ranking, evaluation and the publication of the list will be final.
          There will be anonymity of those not listed.
        </li>
        <li className="mb-4">
          All entries must be submitted by 5pm on 30 June 2026. In the event
          that this falls on a weekend, the submission deadline will be on the
          next working day.
        </li>
      </ul>

      <div className="mt-15 text-xs">
        <ul className="mb-6 list-none">
          <li>
            <strong>The Enterprise 50 Secretariat</strong>
          </li>
          <li>c/o KPMG 12 Marina View</li>
          <li>#15-01 Asia Square Tower, #2</li>
          <li>Singapore 018961</li>
        </ul>

        <ul className="mb-6 list-none">
          <li>Website:</li>
          <li>
            <a
              className="text-blue-175 hover:text-gray-750 hover:underline"
              href={ENTERPRISE_50_URL}
              target="_blank"
              rel="noreferrer"
            >
              enterprise50.org
            </a>
          </li>
        </ul>

        <ul className="list-none">
          <li>Email:</li>
          <li>
            <a
              className="text-blue-175 hover:text-gray-750 hover:underline"
              href="mailto:enterprise50@kpmg.com.sg"
            >
              enterprise50@kpmg.com.sg
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RulesPage;
